import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { isArray, TranslatePipe } from '@ngx-translate/core';
import {
  OnyxInformationHeadingComponent,
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { ContractorInvoiceCollectiveIssueTermComponent } from '../../../dashboard/management-panel/contractors/common/components/contractor-invoice-collective-issue-term/contractor-invoice-collective-issue-term.component';
import type {
  ContractorInvoice,
  ContractorInvoiceDocuments,
  ShippingType,
} from '../../../dashboard/management-panel/contractors/common/interfaces/contractor';
import { DictionaryCode } from '../../enums/dictionary-code';
import { JoinPipe } from '../../pipes/join.pipe';

@Component({
  selector: 'app-contractor-shipping-methods',
  imports: [
    OnyxInformationRowComponent,
    TranslatePipe,
    ContractorInvoiceCollectiveIssueTermComponent,
    OnyxTooltipDirective,
    NgTemplateOutlet,
    JoinPipe,
    OnyxInformationListComponent,
    OnyxInformationHeadingComponent,
  ],
  templateUrl: './contractor-shipping-methods.component.html',
  styleUrl: './contractor-shipping-methods.component.scss',
})
export class ContractorShippingMethodsComponent {
  public readonly invoice = input.required<ContractorInvoice | null>();
  public readonly invoiceDocuments =
    input.required<ContractorInvoiceDocuments | null>();
  public readonly variant = input<'s' | 'm'>('m');

  protected readonly DictionaryCode = DictionaryCode;

  protected contractorInvoiceDocuments = computed(() => {
    const invoiceDocuments = this.invoiceDocuments();
    if (!invoiceDocuments) return null;

    return {
      ...invoiceDocuments,
      internalPortal: this.formatInternalPortal(invoiceDocuments.shippingType),
      requireDocuments: Object.values(invoiceDocuments.shippingType).some(
        (value) => Boolean(isArray(value) ? value.length : value),
      ),
    };
  });

  protected contractorInvoice = computed(() => {
    const invoice = this.invoice();
    if (!invoice) return null;

    return {
      ...invoice,
      internalPortal: this.formatInternalPortal(invoice.shippingType),
    };
  });

  private formatInternalPortal(shippingType: ShippingType): string[] | null {
    return shippingType.internalPortal
      ? Object.values(shippingType.internalPortal)
      : null;
  }
}
